import { ExtAdapter, ExtCancelLoginError, ExtNotSupportError } from "@hyext-inner/ext-web-comp";
import { InnerExtFunctionalProvider } from "@hyext-inner/inner-ext-web-comp";
import { reportProductEvent } from "../../util/ya";
import HyExtAdapter from "../adapters/HyExtAdapter";

export default class HyExtFunctionalProvider extends InnerExtFunctionalProvider {
  async getTid(_:any, adapter:ExtAdapter):Promise<GetTidRsp> {
    const { lUid, sGuid, sToken, sHuYaUA, sCookie, iTokenType } = await adapter.getUserId()
    return {
      tId: { 
        lUid: Number(lUid), sGuid, sToken, sHuYaUA, sCookie, iTokenType
      }
    }
  }
  addActionEventWithExtraInfo(req:AddActionEventWithExtraInfoReq, adapter:ExtAdapter):Promise<void> {
    return reportProductEvent(req.eid, req.label, JSON.stringify(req.extraInfo
      ? req.extraInfo.prop
          ? req.extraInfo.prop
          : req.extraInfo
      : {}
    ))
  }
  async showLogin(_:any, adapter:ExtAdapter):Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapter
    const userInfo = await hyExtAdapter.getHyUserInfo()
    if (!Number(userInfo.uid)) {
      hyExtAdapter.TT.login.login()
      return new Promise((resolve, reject) => {
        hyExtAdapter.TT.login.on('loginClose', () => reject(new ExtCancelLoginError()))
      })
    } else {
      return Promise.reject(new ExtNotSupportError('用户已登录'))
    }
  }
  async getHostInfo(_:any, adapter:ExtAdapter):Promise<GetHostInfoRsp> {
    return Promise.resolve({
      name: 'huya_web',
      platform: 'web',
      version: 'latest',
      baseVersion: ''
    })
  }
  async openExternalUrl(req: OpenExternalUrlReq, adapter: ExtAdapter): Promise<void> {
    window.open(req.url, '_blank')
    return Promise.resolve()
  }
}